import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import MnpDataModule from './mnpData/index.js'
import SimDataModule from './simData/index.js'
import BelatedPortingCart from './cart/belatedPortingCart.js'

const initialState = {
  step: 'mnpData',
  confirmResult: {
    contractId: '',
    success: false
  },
  processId: null,
  contractDocumentUrl: null
}

const BelatedPortingModule = {
  namespaced: true,
  modules: {
    _mnpData: MnpDataModule,
    _simData: SimDataModule,
    _cart: BelatedPortingCart
  },
  state: initialState,
  getters: {
    step: state => {
      return state.step
    },
    processId: state => {
      return state.processId
    },
    confirmResult: state => {
      return state.confirmResult
    },
    contractDocumentUrl: state => {
      return state.contractDocumentUrl
    }
  },
  mutations: {
    setStep (state, step) {
      state.step = step
    },
    setProcessId (state, processId) {
      state.processId = processId
    },
    setContractDocumentUrl (state, contractDocumentUrl) {
      state.contractDocumentUrl = contractDocumentUrl
    },
    setConfirmResult (state, confirmResult) {
      state.confirmResult = confirmResult
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  },
  actions: {
    async initiate ({ commit, state, getters, rootGetters }) {
      const mnpPortingData = getters['_mnpData/portingData']
      const mnpProvider = getters['_mnpData/provider']
      const mnpContractHolder = getters['_mnpData/contractHolder']
      const targetTariffoptions = getters['_cart/targetTariffoptions']
      const targetTariff = getters['_cart/targetTariff']
      const simType = getters['_simData/simType']
      let tariffoptions = null
      if (targetTariffoptions && Array.isArray(targetTariffoptions) && targetTariffoptions.length === 1) {
        tariffoptions = {
          TariffoptionInput: {
            tariffoptionId: targetTariffoptions[0].tariffoptionId
          }
        }
      }
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation belatedPorting ($mpnInInput: InitiateMnpInput!) {
            initiateMnpIn (initiateMnpInput: $mpnInInput){
              contractUrl
              processId
            }
          }`,
        variables: {
          mpnInInput: {
            person: {
              gender: 'FEMALE', // wird nicht benötigt, muss aber gefüllt sein.
              birthdate: mnpContractHolder.birthDate,
              firstName: mnpContractHolder.firstName,
              lastName: mnpContractHolder.lastName
            },
            portation: {
              executionDate: mnpPortingData.dateType,
              msisdn: mnpPortingData.msisdn,
              network: mnpProvider.network,
              provider: mnpProvider.key
            },
            consent: true,
            product: {
              tariffIdentifier: targetTariff.tariffId,
              promotions: null,
              tariffoptions: tariffoptions,
              article: null,
              promoCode: null,
              simType: simType
            }
          }
        }
      }).then((response) => {
        if (response.data.initiateMnpIn) {
          commit('setProcessId', response.data.initiateMnpIn.processId)
          commit('setContractDocumentUrl', response.data.initiateMnpIn.contractUrl)
        } else {
          throw new Error('Initiate failed')
        }
      }).catch((error) => {
        throw error
      })
    },
    async confirm ({ commit, state, rootState, rootGetters, getters, dispatch }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`
          mutation belatedPorting ($mpnInInput: ConfirmMnpInput!) {
            confirmMnpIn (confirmMnpInput: $mpnInInput){
              contractId,
              success
            }
          }`,
        variables: {
          mpnInInput: {
            processId: getters.processId
          }
        }
      }).then((response) => {
        if (response.data.confirmMnpIn && response.data.confirmMnpIn.success) {
          commit('setConfirmResult', {
            contractId: 'bnp' + response.data.confirmMnpIn.contractId,
            success: response.data.confirmMnpIn.success
          })
          commit('Transaction/removeTransactionId', 'ordering', { root: true })
        } else {
          throw new Error('Confirm failed')
        }
      }).catch((error) => {
        throw error
      })
    },
    resetState  ({ state, commit, dispatch }) {
      commit('_mnpData/resetState', { root: true })
      commit('_simData/resetState', { root: true })
      commit('_cart/resetState', { root: true })
      commit('resetState')
      return true
    }
  }
}

export default BelatedPortingModule
